import { render } from "./App.vue?vue&type=template&id=1ce9a5d8"
const script = {}
script.render = render

export default script